import $ from 'jquery';
import debug from 'debug';
import { GAServices } from '../../../services/ga-services';
// import keystroke from './keystroke';

const PLUGIN_NAME = 'SearchDropdown';

const log = debug('search-dropdown');

class SearchDropdown {
	constructor(element, options) {
		log('construct', element, options);

		this.options = options;
		this.element = element;
		this.$element = $(element);
		this.queryList=[];

		this.options.typingDebounceMs = parseInt(this.options.typingDebounceMs);

		this.options.escapeKeyCodes = this.options.escapeKeyCodes.split(' ');

		this.hasFocus = false;
		this.focsusedElement = null;
		this.searchCancelled = false;

		this.searchField = this.selectors.selectTarget(
			this.options.searchInputSelector,
			this.$element
		);
		this.submitButton = this.selectors.selectTarget(
			this.options.searchSubmitSelector,
			this.$element
		);
		this.cancelButton = this.selectors.selectTarget(
			this.options.searchCancelSelector,
			this.$element
		);
		this.resultsContainer = this.selectors.selectTarget(
			this.options.resultsContainerSelector,
			this.$element
		);

		this.templateSource = this.selectors.selectTarget(
			this.options.dropdownTemplateSelector,
			this.$element
		);
		this.template = this.templateSource.text();

		// Slurp up template and stick it into data
		// Not sure what problem this solves
		// Commented out as it prevents multiple search instances from sharing the template
		// this.templateSource.data('original-content', this.template);
		// this.templateSource.empty();

		window.strings = this.strings;

		this.watch();

		log('ready', this.$target);
	}

	watch() {
		const debounceImmediate = this.options.typingDebounceEdge === 'leading';
		this.searchField.on(
			'keyup',
			this.fn.debounce(
				this.send.bind(this),
				this.options.typingDebounceMs,
				debounceImmediate
			)
		);

		// Respond to clear search button click (IE/Edge)
		this.searchField.on('mouseup', () => {
			const input = this.searchField;
			const oldValue = input.val();
			if (oldValue === '') {
				return false;
			}
			setTimeout(() => {
				const newValue = input.val();
				if (newValue === '') {
					this.cancel();
				}
			}, 0);

		});

		$(document).on('click', event => {
			const hasTarget = this.$element.has(event.target);
			if (hasTarget && hasTarget.length) {
				this.open();
			} else {
				this.close();
			}
		});

		this.cancelButton.on('click', () => {
			log('cancelClick');
			this.cancel();
		});

		log('watching');
	}

	addToQueryList(q,qid){
		this.queryList.push({
			queryId : qid,
			query : q,
			ignore:false,
			hasFinsihed:false
		});
	}

	removeFromQueryList(queryEl){
		// just make sure it exists and has finished
		var foundIndex = this.queryList.indexOf(queryEl);
		if(foundIndex>-1 && queryEl.hasFinsihed == true){
			this.queryList.splice(foundIndex,1);
		}
	}

	getQueryFromList(qid){
		return this.queryList.find(element => element.queryId ==qid);
	}

	setIgnoreForPreviousQueries(baseQuery){

		const indexOfCaseQuery= this.queryList.indexOf(baseQuery);

		for (let index = 0; index <indexOfCaseQuery ; index++) {
			const element = this.queryList[index];
				element.ignore=true;
		}
	}

	send(event) {
		this.close();
		const query = this.searchField.val();
		const { keyCode } = event;
		const {
			ignoreKeyCodes,
			escapeKeyCodes,
			minQueryLength,
			errorClass,
			sendingClass,
			openClass,
			url,
			startPageId,
			language
		} = this.options;

		log('send', query);

		// var withinAllowedRange = (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 65 && event.keyCode <= 90);

		if (query && query.length < minQueryLength) {
			this.$element.trigger(`${PLUGIN_NAME}.notMinLength`);

			log('minQueryLength', query.length);
			return;
		} else if (ignoreKeyCodes.includes(''+keyCode)) {
			this.$element.trigger(`${PLUGIN_NAME}.keyIgnored`, { keyCode });

			log(
				`key[${
					event.keyCode
				}] ignored since it's in options.ignoreKeyCodes[${ignoreKeyCodes}]`
			);
			return;
		} else if (escapeKeyCodes.includes(''+event.keyCode)) {
			this.$element.trigger(`${PLUGIN_NAME}.escape`);
			this.close();
			return;
		} else if (query && query.length) {
			this.submitButton.addClass(this.options.buttonSubmittingClass);
			this.$element.trigger(`${PLUGIN_NAME}.beforeSend`);
			this.$element.addClass(sendingClass);
			this.$element.removeClass(errorClass);

			// add it to query list
			const queryId=(Date.now() + Math.random()).toString(36);
			this.addToQueryList(query,queryId);

			$.ajax({
				url,
				data: {
					q: query,
					startPageId: startPageId,
					language: language
				},
				success: (data, status, request) => {
					log('success', data, status);

					const successQuery= this.getQueryFromList(queryId);
					successQuery.hasFinsihed=true;
					if(successQuery.ignore == true){
						log('ignored success', data, status,successQuery);
					}
					else{
						this.$element.removeClass(errorClass);
						this.render(data);
						this.$element.addClass(openClass);
						this.$element.trigger(`${PLUGIN_NAME}.rendered`);
						this.setIgnoreForPreviousQueries(successQuery); // Set previous query results to be ignored if they show up later.
						this.removeFromQueryList(successQuery);// Finally remove query from list (don't want to overload the list)
					}
				},
				error: (data, status, request) => {
					log('error', data, status);

					this.$element.removeClass(openClass);
					this.$element.addClass(errorClass);
					this.$element.trigger(`${PLUGIN_NAME}.error`, {
						data,
						status,
						request
					});
				},
				complete: () => {
					this.$element.removeClass(sendingClass);
					this.submitButton.removeClass(this.options.buttonSubmittingClass);
				}
			});
		} else {
			this.cancel();
		}

		this.$element.trigger(`${PLUGIN_NAME}.afterSend`);
	}

	onFocusChanged(event) {
		log('onFocusChanged', event);
		this.focusedElement = event.toElement;
		const hasFocus = this.$element.has(this.focusedElement);
		this.hasFocus = hasFocus && hasFocus.length > 0;

		logger.log('onFocusIn.hasFocus', this.hasFocus);

		if (!this.hasFocus) {
			this.fn.debounce(this.close.bind(this), 50);
		}
	}

	render(data) {
		log('render', data, this.template);
		const context = Object.keys(data).reduce((result, key) => {
			const value = data[key];
			result[key] = value;
			if (Array.isArray(value)) {
				result[`${key}IsEmpty`] = value.length === 0;
			}
			return result;
		}, {});
		const html = this.strings.mustache(this.template, context);
		const dom = GAServices.addGAForSearchAutoComplete(html, context.Results);
		log('rendered', html);
		this.resultsContainer.html(dom);
	}

	reset(event) {
		log('reset');
		this.submitButton.removeClass(this.options.buttonSubmittingClass);
		this.searchField.val('');
		this.searchField.EmitOnDirty('clean');
		this.resultsContainer.empty();
	}

	// Display suggestions
	open() {
		log('open');
		this.$element.addClass(this.options.openClass);
		this.$element.trigger(`${PLUGIN_NAME}.open`);
	}

	close() {
		log('close');
		this.$element.removeClass(this.options.hasErrorClass);
		this.$element.removeClass(this.options.sendingClass);
		this.$element.removeClass(this.options.openClass);
		this.$element.trigger(`${PLUGIN_NAME}.closed`);
	}

	cancel() {
		log('cancel');
		this.searchCancelled = true;
		this.reset();
		this.close();
	}
}

SearchDropdown.DEFAULTS = {
	minQueryLength: 3,
	ignoreKeyCodes: '9 16 17 18 33 34 35 36 37 38 39 40 44 91 92 93 224',
	escapeKeyCodes: '27',
	searchInputSelector: '(here) [data-search-dropdown__input-field]',
	searchCancelSelector: '(here) [data-search-dropdown__cancel-button]',
	searchSubmitSelector: '(here) [data-search-dropdown__submit-button]',
	dropdownTemplateSelector: '(here) #search-dropdown--template',
	resultsContainerSelector: '(here) [data-search-dropdown__result-container]',
	typingDebounceMs: 500,
	typingDebounceEdge: 'trailing',
	openClass: 'search-dropdown--is-open',
	sendingClass: 'search-dropdown--is-sending',
	errorClass: 'search-dropdown--error',
	buttonSubmittingClass: 'is-submitting',
	placement: 'bottom',
	placementTarget: '(self)'
};

export default SearchDropdown;



// WEBPACK FOOTER //
// ./client/src/core/components/search/dropdown/search-dropdown.js